import { render, staticRenderFns } from "./TagsTable.vue?vue&type=template&id=a1bf0f7e&"
import script from "./TagsTable.vue?vue&type=script&lang=ts&"
export * from "./TagsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports